import React from 'react'
import welcome from "../../../statics/assets/images/1408508.png"

function AnalyticsPage() {
    return (
        <div className="AnalyticsPage text-center mt-5">
            <img src={welcome} alt="welcome"/>
        </div>
    )
}

export default AnalyticsPage